import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NotificationBadgeOptions, Positions } from '@capturum/ui/api';

@Component({
  selector: 'cap-notification-badge',
  templateUrl: './notification-badge.component.html'
})
export class CapturumNotificationBadgeComponent implements OnInit, OnChanges {
  @Input() public badgeSize: string = '1.5rem';
  @Input() public width: string;
  @Input() public height: string;
  @Input() public borderRadius: string = '50%';
  @Input() public position: Positions | 'none' = Positions.TOP_RIGHT;
  @Input() public label: string;
  @Input() public icon: string;
  @Input() public fontColor: string;
  @Input() public fontSize: string;
  @Input() public fontWeight: string;
  @Input() public backgroundColor: string;
  @Input() public showBorder: boolean = true;
  @Input() public showBadge: boolean = true;
  @Input() public borderType: string = 'solid';
  @Input() public borderSize: string = '1px';
  @Input() public borderColor: string = '';
  @Input() public options: NotificationBadgeOptions;

  public ngOnInit(): void {
    if (this.fontSize === undefined) {
      this.fontSize = this.getCSSCenter(this.badgeSize);
    }
  }

  public ngOnChanges({ options }: SimpleChanges): void {
    if (options && options.currentValue !== undefined) {
      for (const name of Object.keys(options.currentValue)) {
        this[name] = options.currentValue[name];
      }
    }
  }

  public getBadgeStyles(): any {
    const width = this.width || this.badgeSize;
    const height = this.height || this.badgeSize;
    const positioning = {};

    if (this.hasPosition()) {
      positioning[this.position.split('-')[0]] = this.getCSSCenter(`-${height}`);
      positioning[this.position.split('-')[1]] = this.getCSSCenter(`-${width}`);
    }

    return {
      ...positioning,
      width,
      height,
      backgroundColor: this.backgroundColor,
      color: this.fontColor,
      fontSize: this.fontSize,
      fontWeight: this.fontWeight,
      borderRadius: this.borderRadius,
      border: this.showBorder ? `${this.borderType} ${this.borderSize} ${this.borderColor}` : 'none'
    };
  }

  public hasPosition(): boolean {
    return this.position !== 'none';
  }

  public getCSSCenter(CSSUnit: string): string {
    return `calc(${CSSUnit} / 2)`;
  }
}
